<script setup lang="ts">
import Logo from '~/components/logos/Logo.vue'
import Isologo from '~/components/logos/IsoLogo.vue'
import LanguagesSwitching from '~/components/LanguagesSwitching.vue'

const localePath = useLocalePath()
</script>

<template>
	<header class="header bg-primary-500 py-4">
		<div class="container">
			<div class="flex justify-between items-center">
				<NuxtLink
					:to="localePath('/')"
					aria-label="Luckywise360 – Home Page"
				>
					<Logo class="w-52 hidden smm:flex" />
					<Isologo
						class="text-neutral-50 flex smm:hidden"
						:size="25"
					/>
				</NuxtLink>
				<LanguagesSwitching class-rounded="rounded-full" />
			</div>
		</div>
	</header>
</template>
